// src/hooks/useProcuringEntityStats.js
import { useContext, useEffect } from "react";
import { AppContext } from "../context/AppContext";


const useProcuringEntityStats = () => {
  const { 
    selectedReportID,
    selectedProcuringEntity,
    procuringEntityStatsById,
    ensureProcuringEntityStatsLatest,
  } = useContext(AppContext);
 

useEffect(() => {
  if (selectedProcuringEntity) ensureProcuringEntityStatsLatest(selectedProcuringEntity);
}, [selectedProcuringEntity, selectedReportID, ensureProcuringEntityStatsLatest]);
  
    


  const entry = procuringEntityStatsById?.[selectedProcuringEntity] || {};
  const data = entry.data || { physicalProgressData: [], financialProgressData: [], summaries: [] };
  const loading = !!entry.loading && !entry.data;
  const error = entry.error || null;

  return { loading, error, ...data };
};

export default useProcuringEntityStats;